import React from 'react';
import { Phone, Calendar, Clock } from 'lucide-react';
import { heroFeatures } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://roseville-smile-revamp.lovable.app/assets/hero-dental-BiKwPMMR.jpg"
          alt="Happy patients smiling - Sunshine Dental Care in Roseville, CA"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-700/95 via-cyan-600/90 to-cyan-500/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 min-h-screen flex items-center">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-amber-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-8 animate-pulse">
            <Clock size={16} />
            <span>Same-Day Emergency Appointments Available</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Dentist in{' '}
            <span className="text-amber-400">Roseville, CA</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Safe & comfortable dental care with{' '}
            <a href="#about" className="text-amber-400 hover:text-amber-300 underline decoration-2 underline-offset-4">
              Dr. Maichou Yang DDS
            </a>
            . From cosmetic dentistry to emergency care, we restore lives one smile at a time.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href="tel:9167731122"
              className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              <Phone size={20} />
              <span>Call (916) 773-1122</span>
            </a>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-lg border-2 border-white/30 transition-all duration-300 backdrop-blur-sm"
            >
              <Calendar size={20} />
              <span>Book Appointment</span>
            </button>
          </div>

          {/* Feature Tags */}
          <div className="flex flex-wrap gap-4">
            {heroFeatures.map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-2 text-white/90"
              >
                <div className={`w-3 h-3 rounded-full ${feature.color}`} />
                <span className="text-sm font-medium">{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-white/50 flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full animate-scroll" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
